import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { WizardStep } from '../../../../wizard/wizard.component';
import { OrderBatchLogisticsWizardService } from 'src/app/services/wizard/logistic/order-batch-send-wizard.service';
import { BehaviorSubject } from 'rxjs';
import { AbstractControl, FormArray, FormGroup, FormBuilder } from '@angular/forms';
import { OrderBatchItem } from '../../../../model/logistics/order/index';
import { NotificationToastService } from '../../../../services/notification-toast.service';
import { StudyReportSendWizardService } from '../../../../services/wizard/logistic/study-report-send-wizard';
import { StudyReportBatchItemInfo } from 'src/app/model/logistics/study-report';

@Component({
  selector: 'app-send-study-report-logistics-item',
  templateUrl: './send-study-report-logistics-item.component.html',
  styleUrls: ['./send-study-report-logistics-item.component.css']
})
export class SendStudyReportLogisticsItemComponent implements OnInit, WizardStep {

    form: FormGroup;
    loading: boolean;
    isInit: boolean;

    @ViewChild('newProtocol', {static: false}) newProtocol: ElementRef;
    displayColumns = ['Protocol', 'buttons', 'PracticeRegionName', 'PatientFullName', 'PreviousStudies', 'PreviousStudiesAmount'
    , 'PreviousStudiesDetails', 'RegionName'];

    dataSource = new BehaviorSubject<AbstractControl[]>([]);

  constructor(private studyReportSendWizardService: StudyReportSendWizardService
    , private notificationToastService: NotificationToastService
    , private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({
      StudyReportBatchItems: this.formBuilder.array([]),
      NewProtocol: ['']
    });
  }

  get completed(): boolean { return true; }
  get studyReportBatchItemsForm() { return <FormArray>this.form.get('StudyReportBatchItems'); }
  get valid(): boolean {
    return this.completed;
  }


  ngOnInit(): void {
    this.isInit = true;
  }

  activate(): void {
    const items = this.studyReportSendWizardService.getStudyReportBatchItems();
    this.addItems(items);
    setTimeout(() => this.newProtocol.nativeElement.focus(), 0);
  }

  private addItems(items: StudyReportBatchItemInfo[]) {
    this.form.controls.OrderBatchItems = this.formBuilder.array([]);
    items.forEach((item) => {

       if (item.Warning) {
              this.notificationToastService
                .info('El protocolo tiene informes con el siguiente error: ' + item.Warning, 'Logistica');
            }


      const row = this.formBuilder.group({
        Protocol: [item.Protocol],
        Id: [item.Id],
        StudyReportBatchId: [item.StudyReportBatchId],
        StudyReportId: [item.StudyReportId],
        PracticeRegionName: [item.PracticeRegionName],
        PatientFullName: [item.PatientFullName],
        PreviousStudiesDetails: [item.PreviousStudiesDetails],
        PreviousStudies: [item.PreviousStudies],
        PreviousStudiesAmount: [item.PreviousStudiesAmount],
        RegionName: [item.RegionName]
      });
      this.studyReportBatchItemsForm.push(row);
      this.dataSource.next(this.studyReportBatchItemsForm.controls);
    });
  }

  save(): void {
  }

  async addProtocol() {
    try {
      if (this.form.controls.NewProtocol.value !== '') {
        this.loading = true;
        const items = await this.studyReportSendWizardService.addProtocol(this.form.controls.NewProtocol.value);
        this.addItems(items);
      } else {
        this.notificationToastService.error('Debe ingresar el protocolo', 'Envio de informes');
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Envio de informes');
    } finally {
      this.form.patchValue({ NewProtocol: ''});
      setTimeout(() => this.newProtocol.nativeElement.focus(), 0);
      this.loading = false;
    }
  }

  deleteProtocol(index: number): void {
    this.studyReportSendWizardService.removeStudyReportBatchItem(index);
    this.studyReportBatchItemsForm.removeAt(index);
    this.dataSource.next(this.studyReportBatchItemsForm.controls);
    setTimeout(() => this.newProtocol.nativeElement.focus(), 0);
  }

  displayProtocol(index: number): string {
    return this.studyReportBatchItemsForm.controls[index].value.Protocol;
  }

  displayPracticeRegionName(index: number): string {
    return this.studyReportBatchItemsForm.controls[index].value.PracticeRegionName;
  }

  displayPatientFullName(index: number): string {
    return this.studyReportBatchItemsForm.controls[index].value.PatientFullName;
  }

  displayPreviousStudiesDetails(index: number): string {
    return this.studyReportBatchItemsForm.controls[index].value.PreviousStudiesDetails;
  }

  displayPreviousStudies(index: number): string {
    return this.studyReportBatchItemsForm.controls[index].value.PreviousStudies;
  }

  displayPreviousStudiesAmount(index: number): string {
    return this.studyReportBatchItemsForm.controls[index].value.PreviousStudiesAmount;
  }

  displayRegionName(index: number): string {
    return this.studyReportBatchItemsForm.controls[index].value.RegionName;
  }
}
